var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 46.5H5.5C4.09987 46.5 3.3998 46.5 2.86502 46.2275C2.39462 45.9878 2.01217 45.6054 1.77248 45.135C1.5 44.6002 1.5 43.9001 1.5 42.5V1.5M46.5 11.5L32.9142 25.0858C32.4192 25.5808 32.1717 25.8283 31.8863 25.9211C31.6352 26.0026 31.3648 26.0026 31.1137 25.9211C30.8283 25.8283 30.5808 25.5808 30.0858 25.0858L25.4142 20.4142C24.9192 19.9192 24.6717 19.6717 24.3863 19.5789C24.1352 19.4974 23.8648 19.4974 23.6137 19.5789C23.3283 19.6717 23.0808 19.9192 22.5858 20.4142L11.5 31.5M46.5 11.5H36.5M46.5 11.5V21.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.e609b90854606f2d9a2c10c0ddcb591d.svg";
export { ForwardRef as ReactComponent };